import React from "react"

import { SimpleAudioPlayer } from "@/audio"

import type { RunRowLike } from "@/types/RunRow"

export const AudioCell = React.memo(({ item }: { item: RunRowLike }) => {
  if (!item.simulation_s3_bucket) {
    return null
  }

  return (
    // Fills the (already flex, overflow-clipping) table cell in normal flow. The
    // @coval/ui grid cell is not a positioning context, so an absolute-inset
    // layout would escape to the row.
    <div
      role="presentation"
      className="flex w-full min-w-0 items-center"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="min-w-0 flex-1">
        <SimpleAudioPlayer
          bucket={item.simulation_s3_bucket ?? ""}
          audioKey={item.simulation_s3_key ?? ""}
          compact
        />
      </div>
    </div>
  )
})
AudioCell.displayName = "AudioCell"
